module.exports = __webpack_public_path__ + "media/images/icons/dropdown_arrow_down-d357b82c7ccca906814e2019e153e2bb.svg";